import {
  Plus,
  Handshake,
  Megaphone,
} from 'lucide-react';
import { useChatStore } from '../../store/chatStore'; // adjust path if needed

function ChatSidebar() {
  const {
    activeRole,
    setRole,
    messages,
    history,
    newChat,
    sidebarOpen,
    setSidebarOpen,
    loadSession,
    activeSessionId,
  } = useChatStore();

  const roleMessages = messages[activeRole] || [];
  const roleHistory =
    history.filter(
      (h) => h.role === activeRole
    ) || [];

  const tabStyle = (role) => {
    const active = activeRole === role;

    if (!active) {
      return {
        background: 'transparent',
        color: 'rgba(255,255,255,0.55)',
      };
    }

    return role === 'pre_sales'
      ? { background: 'linear-gradient(264.28deg, #6666CC -38.2%, #CC0066 103.12%)', color: '#ffffff' }
      : { background: 'linear-gradient(264.28deg, #6666CC -38.2%, #CC0066 103.12%)', color: '#ffffff' };
  };

  const content = (
    <div
      className="h-full flex flex-col"
      style={{ background: '#0d1b2e' }}
    >
      {/* Role tabs */}
      <div className="p-3">
        <div
          className="flex rounded-[10px] p-1"
          style={{
            background:
              'rgba(255,255,255,0.06)',
          }}
        >
          {['pre_sales', 'marketing'].map(
            (r) => (
              <button
                key={r}
                className="flex-1 flex items-center justify-center gap-1.5 py-2 rounded-lg text-[13px] transition-all"
                style={{
                  ...tabStyle(r),
                  fontWeight:
                    activeRole === r ? 600 : 500,
                }}
                onClick={() => setRole(r)}
              >
                {r === 'pre_sales' ? (
                  <Handshake size={14} />
                ) : (
                  <Megaphone size={14} />
                )}
                {r === 'pre_sales'
                  ? 'Pre-Sales'
                  : 'Marketing'}
              </button>
            )
          )}
        </div>

        <p
          className="text-[11px] mt-2 px-1"
          style={{
            color:
              'rgba(255,255,255,0.40)',
          }}
        >
          {roleMessages.length} messages
        </p>
      </div>

      {/* New chat */}
      <div className="px-3 mb-2">
        <button
          className="w-full flex items-center gap-2 px-3 py-2.5 rounded-lg text-[13px] transition-colors"
          style={{
            background:
              'rgba(0, 250, 194, 1)',
            border:
              '1px solid rgba(255,255,255,0.15)',
            color:
              '#0a1628',
            fontWeight: 600,
          }}
          onClick={() => {
            newChat();
            setSidebarOpen(false);
          }}
          onMouseEnter={(e) =>
          (e.currentTarget.style.background =
            'transparent', e.currentTarget.style.color = 'rgba(0, 250, 194, 1)', e.currentTarget.style.border = '1px solid rgba(0, 250, 194, 1)')
          }
          onMouseLeave={(e) =>
          (e.currentTarget.style.background =
            'rgba(0, 250, 194, 1)', e.currentTarget.style.color = '#0a1628')
          }
        >
          <Plus size={14} />
          New Chat
        </button>
      </div>

      {/* Divider */}
      <div
        className="mx-3"
        style={{
          height: 1,
          background:
            'rgba(255,255,255,0.08)',
        }}
      />

      {/* History */}
      <div className="flex-1 overflow-y-auto nitor-scrollbar px-2 py-2">
        {roleHistory.length === 0 ? (
          <p
            className="text-center text-[12px] mt-8"
            style={{
              color:
                'rgba(255,255,255,0.35)',
            }}
          >
            No history yet
          </p>
        ) : (
          roleHistory.map((h) => {
            const isActive = h.id === activeSessionId;
            return (
              <div
                key={h.id}
                className="px-3 py-2.5 rounded-lg mb-1 cursor-pointer transition-colors"
                style={{
                  color: 'rgba(255,255,255,0.70)',
                  borderLeft: isActive
                    ? '3px solid #00fac2'
                    : '3px solid transparent',
                  background: isActive
                    ? 'rgba(0,250,194,0.07)'
                    : 'transparent',
                }}
                onClick={() => {
                  loadSession(h.id);
                  setSidebarOpen(false);
                }}
                onMouseEnter={(e) =>
                (e.currentTarget.style.background =
                  isActive
                    ? 'rgba(0,250,194,0.12)'
                    : 'rgba(255,255,255,0.06)')
                }
                onMouseLeave={(e) =>
                (e.currentTarget.style.background =
                  isActive
                    ? 'rgba(0,250,194,0.07)'
                    : 'transparent')
                }
              >
                <p className="text-[13px] truncate">
                  {h.title}
                </p>
                <p
                  className="text-[11px] mt-0.5"
                  style={{
                    color: 'rgba(255,255,255,0.35)',
                  }}
                >
                  {new Date(
                    h.timestamp
                  ).toLocaleDateString()}
                </p>
              </div>
            );
          })
        )}
      </div>

      {/* Footer */}
      <div className="p-3 text-center">
        <p
          className="text-[11px]"
          style={{
            color:
              'rgba(255,255,255,0.30)',
          }}
        >
          © 2026 Nitor Infotech. All rights reserved.
        </p>
      </div>
    </div>
  );

  return (
    <>
      {/* Desktop sidebar */}
      <aside
        className="hidden md:block w-[260px] flex-shrink-0 h-full"
        style={{
          borderRight:
            '1px solid rgba(255,255,255,0.08)',
        }}
      >
        {content}
      </aside>

      {/* Mobile overlay */}
      {sidebarOpen && (
        <>
          <div
            className="fixed inset-0 z-40 md:hidden"
            style={{
              background: 'rgba(0,0,0,0.60)',
            }}
            onClick={() =>
              setSidebarOpen(false)
            }
          />
          <aside className="fixed left-0 top-0 bottom-0 w-[260px] z-50 md:hidden">
            {content}
          </aside>
        </>
      )}
    </>
  );
}

export default ChatSidebar;